import { Component, OnInit, ViewChild } from '@angular/core';
import { WebSocketService } from 'src/app/utils/webSocket.service';
import { Permissions } from 'src/app/shared/dto/permissions';
import { StateTypes } from 'src/app/shared/models/common';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css'],
})
export class DashboardComponent implements OnInit {
  public state: string = 'operational_indicators';

  public states: StateTypes[] = [
    {
      name: $localize`:Operational Indicators|label for operational indiactors@@operational_indicators:Operational indicators`,
      value: 'operational_indicators',
      perms: [Permissions.NONE],
      isActive: true,
      icon: 'operational',
    },
    // {
    //   name: 'Financial Indicators',
    //   value: 'financial_indicator',
    //   perms: [Permissions.N ONE],
    // },
    {
      name: $localize`:User Activities|label for user activities@@user_activities:User Activities`,
      value: 'user_activity',
      perms: [Permissions.NONE],
      icon: 'userActivity',
    },
  ];

  constructor(private webSocketService: WebSocketService) {}
  public onStateChange(val: StateTypes['value']) {
    this.state = val;
  }

  ngOnInit(): void {
    const isIndexDBFetched = JSON.parse(localStorage.getItem('isIndexDBFetched') || 'false');
    if (!isIndexDBFetched) {
      this.webSocketService.storeIndexedDbData();
    }
  }
}
